var viewer_caption_default = {
  "fontElementMap": "_1doa2",
  "imageCaption": "Gujqw"
};
export {
  viewer_caption_default as default
};
//# sourceMappingURL=viewer-caption-scss.js.map
